import { Route, Routes } from 'react-router-dom';

import BalanceList from '../components/Bills/BalanceList';

const VendorBalances = () => {
  return (
    <Routes>
      <Route path="/" element={<BalanceList />} />
    </Routes>
  )
}

export default VendorBalances;